import { ScrollView } from 'react-native'

import { useNavigation, useRoute } from '@react-navigation/native'
import { LoggedInNavigation } from '@zet/utils/interface'

import MarketingResourcesContent from './marketingResourcesContent'

const MarketingResource = () => {
  const { params } = useRoute()
  const { navigate } = useNavigation<LoggedInNavigation>()

  return (
    <ScrollView className="bg-white" showsVerticalScrollIndicator={false}>
      <MarketingResourcesContent
        brandId={params?.brandId}
        navigate={navigate}
      />
    </ScrollView>
  )
}

export default MarketingResource
